import { render, staticRenderFns } from "./FamilyActivityCalls.vue?vue&type=template&id=11458a72&scoped=true&"
import script from "./FamilyActivityCalls.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityCalls.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyActivityCalls.vue?vue&type=style&index=0&id=11458a72&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11458a72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
